<template>
    <Vue100vh class="oelteltet base-page">
        <CircleWrap @click.native="goBack" type="back">
            <BackIconThin/>
        </CircleWrap>
        <div class="top">
            <div class="shadow"></div>
            <div class="stripes"></div>
        </div>
        <Vue100vh class="content-wrap">
            <iframe :src="'https://www.youtube.com/embed/s-YUjKE1c14?autoplay=1'" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </Vue100vh>
        <CircleWrap @click.native="wuhuu('cheers',true)" type="cheers">
            <CheersIcon ref="cheers" />
        </CircleWrap>

        <CircleWrap @click.native="wuhuu('clap',true)" type="clap">
            <ClapIcon ref="clap" />
        </CircleWrap>

    </Vue100vh>
</template>

<script>
	import Vue100vh from 'vue-div-100vh'
    import gsap from 'gsap'
	import CircleWrap from "@/components/CircleWrap"
	import BackIconThin from "@/assets/icons/back-thin.svg"
	import CheersIcon from "@/assets/icons/cheers.svg"
	import ClapIcon from "@/assets/icons/clap.svg"
	import {mapState} from "vuex";
	export default {
		name: "Oelteltet.vue",
		components: {
			Vue100vh,
			CircleWrap,
			BackIconThin,
			CheersIcon,
            ClapIcon
		},
		data() {
			return {
				playerVars: {
					autoplay: 1,
                    playsinline: 1,
                    rel: 0,
                    controls: 0,
				},
				hasSentJoin: false
			}
		},
		mounted(){
			// Animation
			let tl = gsap.timeline();
			tl.to(".oelteltet .top", {delay: 0.5, y: 0, opacity: 1, duration: 0.3});
			tl.to(".oelteltet .circle.back", {x: 0, opacity: 1, duration: 0.3});
			tl.to(".oelteltet .content-wrap", {y: 0, opacity: 1, duration: 0.5, ease: 'power2.easeOut'});

			const that = this;
			if(this.hasSentJoin === false)
			{
				this.$vorbasseSocket.emit('join-oeltelt');
				this.hasSentJoin = true;
			}
			this.$vorbasseSocket.listen('receive-wuhuu',(payload) => {
				that.wuhuu(payload,false)
			})
		},
		destroyed()
		{
			this.$vorbasseSocket.emit('leave-oeltelt');
			this.$vorbasseSocket.stopListening('receive-wuhuu');
		},
		methods: {
			playVideo() {
				this.player.playVideo()
			},
			playing() {
			},
			goBack(){
				this.$router.go(-1)
			},
            wuhuu(type, triggerSocket){
	            let elem = document.createElement('div')
	            elem.classList.add('wuhuu')
                let randDir = (Math.floor(Math.random() * 2) === 0) ? 1 : -1
                let randNum = Math.floor(Math.random() * 20)
                let right = (randNum * randDir) + 15 + 'px'
	            elem.style.right = right
	            elem.innerHTML = this.$refs[type].outerHTML
	            this.$el.append(elem)
	            setTimeout(function(){
		            elem.remove()
	            }, 3000)

	            if(triggerSocket)
	                this.handleWuhuuSocket(type)
            },
			handleWuhuuSocket(type){
				const now = new Date().getTime();
				if(now - this.lastSentWuhuu > 1000)
				{
					this.$store.commit('ux/setLastSentWuhuu',now);
					this.$vorbasseSocket.emit('send-wuhuu',type)
				}
			}
		},
		computed: {
			...mapState('ux', {
				systemSettings: 'systemSettings',
				lastSentWuhuu: 'lastSentWuhuu'
			}),
			player() {
				return this.$refs.youtube.player
			}
		}
	}
</script>

<style lang="scss">
    @import "@/assets/scss/_base-page";
    .oelteltet{
        background: $black !important;
        .top{
            .stripes{
                background-color: #D3B934;
                background-image: linear-gradient(90deg, transparent 50%, #DB8E2C 50%);
            }
        }
        .content-wrap{
            position: absolute;
            top: 0px; left: 0px;
            right: 0px; bottom: 0px;
            width: 100%; height: 100%;
            iframe{
                position: absolute;
                top: 0px; left: 0px;
                right: 0px; bottom: 0px;
                width: 100%; height: 100%;
            }
        }
        .circle{
            cursor: pointer;
            &.cheers{
                position: fixed;
                top: auto; left: auto;
                bottom: 15px; right: 185px;
                border: 2px solid transparent;
                background: transparent;
                svg{
                    position: absolute;
                    top: -2px;
                    left: -2px;
                    transform: none;
                }
                @media(max-width: 767px) and (orientation: portrait){
                    right: 100px;
                }
                @media(max-width: 767px) and (orientation: landscape){
                    right: 185px;
                }
                @media(max-width: 349px) and (orientation: portrait){
                    right: 90px;
                }
            }
            &.clap{
                position: fixed;
                top: auto; left: auto;
                bottom: 15px; right: 270px;
                border: 2px solid transparent;
                background: transparent;
                svg{
                    position: absolute;
                    top: -2px;
                    left: -2px;
                    transform: none;
                }
                @media(max-width: 767px) and (orientation: portrait){
                    right: 185px;
                }
                @media(max-width: 767px) and (orientation: landscape){
                    right: 270px;
                }
                @media(max-width: 349px) and (orientation: portrait){
                    right: 165px;
                }
            }
        }
        .wuhuu{
            position: fixed;
            bottom: 0px;
            right: 15px;
            transform: scale(0.5);
            opacity: 1;
            animation-name: fadeupandout;
            animation-duration: 3s;
        }
        @keyframes fadeupandout {
            0%   {transform: scale(0.5);}
            100% {transform: scale(0.5) translateY(-1000px); opacity: 0;}
        }
    }
</style>
